export default "__VITE_ASSET__a7cb42ee__"